import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharingModule } from '../SharedModule';

import { SearchRoutingModule } from './search-routing.module';
import { SearchComponent } from './search.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
	imports: [
		CommonModule,
		SearchRoutingModule,
		SharingModule.forRoot(),
		FormsModule,
		ReactiveFormsModule,
		NgbModule.forRoot(),
	],
	declarations: [
		SearchComponent,
	],
	schemas: [
		CUSTOM_ELEMENTS_SCHEMA,
		NO_ERRORS_SCHEMA,
	],
})
export class SearchModule { }